import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[longPress]',
  standalone: true
})
export class LongPressDirective {

  @Input() longPressDurationMs = 750;

  @Output() longPress = new EventEmitter<void>();
  @Output() shortPress = new EventEmitter<void>();

  private _timeout: ReturnType<typeof setTimeout>;
  private _longPressFired = false;

  @HostListener('touchstart', ['$event'])
  public onTouchStart(event: Event): void {
    this._longPressFired = false;
    event.preventDefault();

    this._timeout = setTimeout(() => {
      this._longPressFired = true;
      this.longPress.emit();
    }, this.longPressDurationMs);
  }

  @HostListener('touchend')
  public onTouchEnd(): void {
    clearTimeout(this._timeout);

    if (!this._longPressFired) {
      this.shortPress.emit();
    }
  }

  @HostListener('touchcancel')
  public onTouchCancel(): void {
    clearTimeout(this._timeout);
  }
}
